<template>
  <transition name="slide-fade">
    <div class="masking" v-if="visible" @click="visible = false">
      <div class="masking-content">
        <div class="masking-tips-site">
          <div class="tips-row">
            <div class="round display-middle">1.</div>
            <div class="display-middle tips-text">
              {{ maskingLang.one.one }}
            </div>
            <div class="display-middle tips-text">
              {{ maskingLang.one.two }}
            </div>
            <img
              class="display-middle blue-menu"
              :src="logoImgs.blueMenuImageSrc"
            />
          </div>
          <div class="tips-row">
            <div class="round display-middle">2. </div>
            <div class="display-middle tips-text">
              {{ maskingLang.two.one }}{{ maskingLang.two.two }}
            </div>
          </div>
        </div>
        <div class="socical-platform">
          <div class="img-list">
            <img src="./images/wechat@2x.png" alt="">
            <img src="./images/facebook@2x.png" alt="">
            <img class="big-img" src="./images/browser@2x.png" alt="">
            <img src="./images/twitter@2x.png" alt="">
            <img src="./images/messenger@2x.png" alt="">
          </div>
          <div class="social-text">{{ maskingLang.two.two }}</div>
        </div>
        <img class="close-icon" src="./images/close.png" alt="">
        <img class="arrow-icon" src="./images/arrow.png" alt="">
      </div>
    </div>
  </transition>
</template>

<script>
import languageUtils from '$common/utils/language';
export default {
  props: {
    value: {
      type: [Boolean, String, Number],
      default: false
    }
  },
  computed: {
    lang() {
      const navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;
      return navigatorLanguage.indexOf('zh') !== -1 ? 'zh' : navigatorLanguage.indexOf('en') !== -1 ? 'en' : 'km';
      // return 'en';
      // return 'km';
    },
    logoImgs() {
      return {
        blueMenuImageSrc: require('./images/blue-menu.png'),
        blueButtonImageSrc: require('./images/blue-button.png'),
        earthImageSrc: require('./images/earth.png'),
        google: {
          src: require('./images/google-logo.png'),
          style: "width: 0.7rem;padding-top: 0.08rem;"
        },
        android: {
          src: require('./images/android-logo.png'),
          style: "width: 0.67rem;"
        },
        apple: {
          src: require('./images/apple-logo.png'),
          style: "width: 0.67rem;padding-top: 0.08rem;"
        }
      };
    },
    maskingLang() {
      return {
        one: {
          one: this.lang === "zh" ? "点击右上角的" : this.lang === 'en' ? "Click On The Upper-right" : 'ចុចលើប៊ូតុងស្តាំខាងលើ',
          two: this.lang === "zh" ? "按钮" : this.lang === 'en' ? "Button" : "ប៊ូតុង"
        },
        two: {
          one: this.lang === "zh" ? "选择" : this.lang === 'en' ? "Select" : 'ជ្រើសរើស',
          two: this.lang === "zh" ? "在浏览器中打开" : this.lang === 'en' ? "Open In Browser" : 'បើកនៅក្នុងBrowser'
        }
      };
    }
  },
  data() {
    return {
      visible: this.value
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('input', val)
    }
  },

  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    }
  }
};
</script>

<style lang="stylus" scoped>
  .display-middle {
    display: inline-block;
    vertical-align: middle;
  }
  .overflow {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
</style>
<style lang="stylus" scoped>
.share-store {
  position: relative;
}

.mask-group-background {
  width: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
}

.share-store-main-content {
  width: 100%;
  height: 100%;
  position: relative;
}

.share-store-main {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.store-name {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft Tai Le;
  font-weight: bold;
  color: #fff;
}

.store-name-zh {
  font-size: 24px;
}

.button-class {
  width: 250px;
  height: 45px;
  background: linear-gradient(360deg, #FEBF01 0%, #FFEE00 100%);
  opacity: 1;
  border-radius: 24px;
  margin: 32px auto 10px auto;
  position: relative;
  transition: all 0.1s;
}

.button-class-active {
  background: linear-gradient(360deg, #FFEE00 0%, #FEBF01 100%);
}

.btn-text {
  font-size: 18px;
  font-family: Source Sans Pro;
  font-weight: bold;
  color: #532C00;
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: opacity .5s;
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: opacity .5s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.masking {
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  background-color: rgba(46, 45, 45, 0.8);
}

.masking-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
}
.masking-tips-site {
  min-width: 100%;
  text-align: center;
  width: fit-content;
  height: 78px;
  color: #fff;
  font-weight: bold;
  padding: 0 20px;
}
.tips-text {
  font-size: 20.5px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
}
.blue-menu {
  margin: 0 5px;
  width: 26px;
  margin-left: 10px;
}
.blue-button {
  margin: 0 5px;
  width: 160px;
}
.blue-button-site {
  position relative
}
.round {
  padding-right: 4px;
}
.earth {
  width: 22px;
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  left: 10px;
}
.earth-text {
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  left: 38px;
  font-size: 14px;
}
.tips-row {
  margin-bottom: 18px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
}

.socical-platform {
  width: calc(100% - 66px);
  margin: 0 33px;
  padding: 20px;
  background: #FFFFFF;
  border-radius: 8px;
  
  .img-list {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .big-img {
      width: 72px;
      height: 72px;
    }
  
    img {
      width: 30px;
      height: 30px;
    }
  }
  .social-text {
    text-align: center;
    padding-top: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}

.arrow-icon {
  position: fixed;
  top: 0;
  right: 0;
  width: 100px;
  height: 100px;
}

.close-icon {
  display: block;
  width: 35px;
  margin: 0 auto;
  padding: 20px 0;
}
</style>
